import { render } from "./ManageJoinRequests.vue?vue&type=template&id=20dd2baf"
import script from "./ManageJoinRequests.vue?vue&type=script&lang=js"
export * from "./ManageJoinRequests.vue?vue&type=script&lang=js"
script.render = render

export default script